// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3dGYJ","label":"SetPasswdForm_label__3eSJJ"};